import styles from './SliderShow.module.scss';
import {Component} from "react";
import type { ReactElement } from "react";
import Swipe from "react-easy-swipe";
import type { SwipePosition } from "react-easy-swipe";
import {ModalComponentService} from "../../common/ModalComponentService";
import AppStorage from "../../storage/AppStorage";
import type { ModalChildProps } from "../ModalComponent";

export interface SliderShowProps extends ModalChildProps {
    slides: ReactElement[];
}

interface SliderShowState {
    slideIndex: number;
}

class SliderShow extends Component<SliderShowProps, SliderShowState> {
    // minimun swipe movement in pixels
    MIN_SWIPE_SIZE = 40;
    swipping = false;

    constructor(props: SliderShowProps) {
        super(props);
        this.state = {
            slideIndex: 0,
        };
        this.getSlide = this.getSlide.bind(this);
        this.go = this.go.bind(this);
        this.goNext = this.goNext.bind(this);
        // swipe handlers
        this.handleSwipeStart = this.handleSwipeStart.bind(this);
        this.handleSwipeMove = this.handleSwipeMove.bind(this);
        this.handleSwipeEnd = this.handleSwipeEnd.bind(this);
    }

    go(newIndex: number): void {
        this.setState({
            slideIndex: newIndex,
        })
    }

    goPrev(): void {
        if (this.state.slideIndex <= 0)
            return;
        this.go(this.state.slideIndex - 1);
    }

    goNext(): void {
        if (this.state.slideIndex >= this.props.slides.length - 1) {
            AppStorage.setOpenedBefore(true);
            ModalComponentService
                .reset();
        }

        this.go(this.state.slideIndex + 1);
    }

    getSlide(): (ReactElement | undefined)[] {
        return this.props.slides.map((slide, index) => {
            if (this.state.slideIndex === index) {
                return <div key={'slide' + index}>
                    {slide}
                </div>
            }
        })
    }

    dotButtonclick(event: React.MouseEvent, index: number): void {
        event.stopPropagation();
        this.go(index);
    }

    /**
     * Swipe handlers (See SwipeableBox)
     */
    handleSwipeStart(): void {
        this.swipping = true;
    }

    handleSwipeMove(position: SwipePosition): void {
        if (!this.swipping) return;
        if (position.x > this.MIN_SWIPE_SIZE) {
            this.goPrev();
        } else if (position.x < -this.MIN_SWIPE_SIZE) {
            this.goNext();
        }
    }

    handleSwipeEnd(): void {
        this.swipping = false;
    }

    render() {
        return (
            <div className={styles.sliderShow} onClick={this.goNext}>
                <div className={styles.sliderViewport}>
                    <Swipe
                        onSwipeStart={this.handleSwipeStart}
                        onSwipeMove={this.handleSwipeMove}
                        onSwipeEnd={this.handleSwipeEnd}
                        className={styles.cardContentWrapper}
                    >
                        <div className={styles.sliderContainer}>
                            {this.getSlide()}
                        </div>
                    </Swipe>

                    <div className={styles.sliderDotButtons}>
                        {this.props.slides.map((_, index) => (
                            <button
                                key={'dot' + index}
                                className={this.state.slideIndex === index? styles.selected : ''}
                                onClick={(event) => {this.dotButtonclick(event, index)}}
                            />
                        ))}
                    </div>
                </div>
            </div>
        )
    }

}

export default SliderShow
